/**
 * Results Templates
 * Filter markup matching Sunspel collection facet classes
 */

window.theme.tagalys = window.theme.tagalys || {}
window.theme.tagalys.templates = window.theme.tagalys.templates || {}
;(function (templates) {
  const strings = window.theme.strings || {}

  function escapeHtml (value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  }

  function handleize (value) {
    return String(value ?? '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
  }

  function chevronIcon () {
    return `
      <svg
        aria-hidden="true"
        focusable="false"
        role="presentation"
        viewBox="0 0 10 6"
        width="10"
        height="6"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
        ></path>
      </svg>
    `
  }

  templates.escapeHtml = escapeHtml
  templates.handleize = handleize

  function formatPriceLabel (amount) {
    const formatMoney = window.BAO?.Utils?.formatMoney
    const cents = Number(amount) * 100
    if (typeof formatMoney !== 'function' || Number.isNaN(cents)) {
      return escapeHtml(String(amount ?? ''))
    }
    return escapeHtml(formatMoney(cents).replace('.00', ''))
  }

  templates.facetWrapper = function (facet, index, idPrefix) {
    if (facet.type === 'range') {
      const step =
        Number(
          document.querySelector('[data-collection-id]')?.dataset.priceStep,
        ) || 25
      const min = Number(facet.min) || 0
      const max = Number(facet.max) || 0
      const selectedMin =
        facet.selected_min != null ? Number(facet.selected_min) : min
      const selectedMax =
        facet.selected_max != null ? Number(facet.selected_max) : max
      const facetId = escapeHtml(facet.id)
      const prefix = escapeHtml(idPrefix)

      return `
        <form data-product-filters-el="form" name="${facetId}" data-form-type="price">
            <range-slider
              class="rng-Slider"
              min="${min}"
              max="${max}"
              step="${step}"
              min-value="${selectedMin}"
              max-value="${selectedMax}"
            >
              <button
                class="rng-Slider_Dot rng-Slider_Dot-left"
                type="button"
                aria-label="${formatPriceLabel(selectedMin)}"
                data-range-slider-el="touchLeft"
              >
                <span class="rng-Slider_DotInner"></span>
              </button>
              <button
                class="rng-Slider_Dot rng-Slider_Dot-right"
                type="button"
                aria-label="${formatPriceLabel(selectedMax)}"
                data-range-slider-el="touchRight"
                style="right: 0%;"
              >
                <span class="rng-Slider_DotInner"></span>
              </button>
              <div class="rng-Slider_Line" data-range-slider-el="line">
                <span class="rng-Slider_LineInner"></span>
                <span class="rng-Slider_LineHighlighter" data-range-slider-el="highlighter"></span>
              </div>
              <input
                class="prc-Range_Input"
                name="${facetId}"
                id="${prefix}-${facetId}-GTE"
                value="${selectedMin}"
                type="hidden"
                min="${min}"
                max="${max}"
                data-range-slider-el="min"
                data-price-range-el="min"
              />
              <input
                class="prc-Range_Input"
                name="${facetId}"
                id="${prefix}-${facetId}-LTE"
                value="${selectedMax}"
                type="hidden"
                min="${min}"
                max="${max}"
                data-range-slider-el="max"
                data-price-range-el="max"
              />
            </range-slider>
        </form>
      `
    }

    const items = (facet.items || [])
      .map(value => templates.facetCheckboxItem(facet, value, idPrefix, index))
      .join('')

    return `
      <form data-product-filters-el="form" name="${escapeHtml(
        facet.id,
      )}" data-form-type="filter">
        <ul class="clc-ProductGridFacet_List">
          ${items}
        </ul>
      </form>
    `
  }

  templates.facetCheckboxItem = function (facet, value, idPrefix, index) {
    const inputId = `${idPrefix}-${handleize(facet.label)}-${escapeHtml(
      value.id,
    )}`
    const isDisabled = value.count === 0 && !value.selected
    const hiddenClass =
      value.count === 0 && !value.selected ? ' util-ScreenReaderOnly' : ''

    return `
      <li class="clc-ProductGridFacet_Item${hiddenClass}">
        <label
          class="clc-ProductGridFacet_Label"
          for="${inputId}"
        >
          <div class="clc-ProductGridFacet_CheckboxContainer">
            <input
              class="clc-ProductGridFacet_Checkbox"
              type="checkbox"
              id="${inputId}"
              name="${escapeHtml(facet.id)}"
              value="${escapeHtml(value.id)}"
              ${value.selected ? 'checked' : ''}
              ${isDisabled ? 'disabled' : ''}
            />
            <span class="clc-ProductGridFacet_CheckboxIndicator"></span>
            <span class="clc-ProductGridFacet_CheckboxIcon"></span>
          </div>
          ${escapeHtml(value.label)}
        </label>
      </li>
    `
  }

  templates.filterDetails = function (facet, index, idPrefix) {
    const hiddenFacets = window.theme.tagalys.hiddenFacets || []
    const label = (facet.label || '').toLowerCase()
    const id = (facet.id || '').toLowerCase()
    const isHidden = hiddenFacets.some(hidden => {
      const needle = String(hidden)
        .toLowerCase()
        .trim()
      if (!needle) return false
      return label.includes(needle) || id.includes(needle)
    })
    const isAvailability =
      label === 'availability' || id.includes('availability')

    if (isHidden || isAvailability) return ''

    const openFacets = window.theme.tagalys.openFacets || []
    const isOpen = openFacets.includes(facet.id)
    const selectedCount = (facet.items || []).filter(item => item.selected)
      .length
    const rangeSelected =
      facet.type === 'range' &&
      ((facet.selected_min != null && facet.selected_min !== facet.min) ||
        (facet.selected_max != null && facet.selected_max !== facet.max))
    const selectedTemplate =
      strings.collection?.filtersSelectedAmount || '([count])'
    const selectedLabel = selectedCount
      ? selectedTemplate
        .replace('[count]', String(selectedCount))
        .replace('{{ count }}', String(selectedCount))
      : rangeSelected
        ? selectedTemplate.replace('[count]', '1').replace('{{ count }}', '1')
        : ''

    return `
      <div class="clc-ProductGridFacets_Item clc-ProductGridFacets_Item-${handleize(
        facet.label,
      )}">
        <details
          class="clc-ProductGridFacet"
          data-index="${idPrefix}-${index}"
          data-facet-id="${escapeHtml(facet.id)}"
          data-product-filters-el="facet"
          ${isOpen ? 'open' : ''}
        >
          <summary
            class="clc-ProductGridFacet_Summary"
            data-product-filters-el="facet-summary"
            aria-expanded="${isOpen ? 'true' : 'false'}"
          >
            <span class="clc-ProductGridFacet_FilterLabel fz-15_21">
              ${escapeHtml(facet.label)}
              <span class="clc-ProductGridFacet_FilterSelected">${escapeHtml(
                selectedLabel,
              )}</span>
            </span>
            ${chevronIcon()}
          </summary>
          <div class="clc-ProductGridFacet_DisplayContainer">
            <div class="clc-ProductGridFacet_Display">
              <div class="clc-ProductGridFacet_Body${
                facet.type === 'range'
                  ? ' clc-ProductGridFacet_Body-price clc-ProductGridFacet_Body-visible'
                  : ''
              }">
                ${templates.facetWrapper(facet, index, idPrefix)}
              </div>
              ${
                facet.type === 'range'
                  ? ''
                  : `
                <footer class="clc-ProductGridFacet_Footer">
                  <button
                    class="clc-ProductGridFacet_RemoveLink fz-15_21"
                    type="button"
                    data-product-filters-el="clear-facet"
                    data-facet-field="${escapeHtml(facet.id)}"
                  >
                    ${escapeHtml(strings.collection?.clearAll || 'Clear all')}
                  </button>
                </footer>
              `
              }
            </div>
          </div>
        </details>
      </div>
    `
  }
})(window.theme.tagalys.templates)
